module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--sidebar group--df-column pab2"
  }, [_c('ui-auth', {
    attrs: {
      "id": _vm.registerForm,
      "success": _vm.success
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-713c4472"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Register.vue
// module id = 481
// module chunks = 0